/**
 * Created by Joker on 2017/11/15.
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import customer from './modules/customer'
import employee from './modules/employee'
import remind from './modules/remind'
import task from './modules/task'
const store = new Vuex.Store({
  state: {
    views: {},
    profile: null,
    revision: 0,
    customerRevision: 0,
    customerChanges: {},
    customerJourney: null,
    id: 3,
    recruitScrollY: 0,
    search: {
      isSearch: false,
      searchOrder: 'created_at',
      searchSubjectType: 'subject',
      searchStatus: '',
      searchLabels: '',
      searchKeyword: '',
      searchStartTime: '',
      searchEndTime: '',

      searchChannels: [],
      searchCustomerTags: [],
      searchSubjects: [],
      searchEmployees: [],
      searchSourceChannelV2: [],
      searchTotalBudgetRange: [],
      searchPriceAcceptanceLevel: [],
      searchPurposeV2: []
    }
  },
  getters: {
    recruitScrollY: state => state.recruitScrollY
  },
  mutations: {
    setProfile(state, profile) {
      state.profile = profile
    },
    refreshData(state) {
      state.revision++
    },
    customerChanged(state, change) {
      const id = Number(change.id || (change.info && change.info.id))
      if (!id) return
      state.customerRevision++
      Vue.set(state.customerChanges, id, { id, info: change.info || null, kind: change.kind || 'followup',
        at: Date.now(), version: state.customerRevision })
    },
    setCustomerJourney(state, journey) { state.customerJourney = journey },
    resetSession(state) {
      state.views = {}
      state.customerChanges = {}
      state.customerRevision = 0
      state.customerJourney = null
      state.profile = null
      state.customer.state.list = []
      state.customer.state.options = []
      state.customer.state.searches = []
      state.employee.state.remind = 0
      state.search = {
        isSearch: false,
        searchOrder: 'created_at',
        searchSubjectType: 'subject',
        searchStatus: '',
        searchLabels: '',
        searchKeyword: '',
        searchStartTime: '',
        searchEndTime: '',
        searchChannels: [],
        searchCustomerTags: [],
        searchSubjects: [],
        searchEmployees: [],
        searchSourceChannelV2: [],
        searchTotalBudgetRange: [],
        searchPriceAcceptanceLevel: [],
        searchPurposeV2: []
      }
      state.revision++
    },
    changeRecruitScrollY(state, recruitScrollY) {
      state.recruitScrollY = recruitScrollY
    }
  },
  actions: {},
  modules: {
    customer,
    employee,
    remind,
    task
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js